<template>
    <div
        v-if="status"
        class="status-alert"
        :class="alertClass"
    >
        {{ statusName }}
    </div>
</template>

<script>
import OrderHistory from "../../models/OrderHistory";
import OrderConstant from "../../const/OrderConstant";

const info = [
    OrderConstant.ORDER_STATUS_CUSTOMER_PLACED,
    OrderConstant.ORDER_STATUS_WSG_WAIT,
    OrderConstant.ORDER_STATUS_PROPOSAL,
]
const success = [
    OrderConstant.ORDER_STATUS_FIXED,
    OrderConstant.ORDER_STATUS_PAYMENT_WAIT,
    OrderConstant.ORDER_STATUS_DELIVERY_PENDING,
    OrderConstant.ORDER_STATUS_DELIVERY_COMPLETE,
]
const danger = [
    OrderConstant.ORDER_STATUS_CANCEL,
]
const warning = [
    OrderConstant.ORDER_STATUS_WSG_APPROVAL,
]
const comp = [
    OrderConstant.ORDER_STATUS_COMPLETE,
]

export default {
    name: 'user-order-status',
    props: {
        status: {
            type: String,
        }
    },
    computed: {
        statusName() {
            return new OrderHistory({status: this.status}).userShowOrderStatusName
        },
        alertClass() {
            if(info.includes(this.status)) {
                return 'alert-info'
            }
            if(danger.includes(this.status)) {
                return 'alert-danger'
            }
            if(success.includes(this.status)) {
                return 'alert-success'
            }
            if(warning.includes(this.status)) {
                return 'alert-warning'
            }
            if(comp.includes(this.status)) {
                return 'alert-comp'
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

.status-alert {
    padding: 0 15px;
    border-radius: 5px;
}

.alert-comp {
    background-color: #e0e3e5;
    border-color:#e0e3e5;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/order/UserOrderStatus.vue